export default __webpack_public_path__ + "static/media/sign-up-for-insurance.c59ab112.svg";